import { render, staticRenderFns } from "./ChampionshipNationalChampionship.vue?vue&type=template&id=eb152f0a&scoped=true&"
import script from "./ChampionshipNationalChampionship.vue?vue&type=script&lang=js&"
export * from "./ChampionshipNationalChampionship.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipNationalChampionship.vue?vue&type=style&index=0&id=eb152f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb152f0a",
  null
  
)

export default component.exports